"use client"

import { ErrorContainer } from "@/components/ErrorContainer"
import Footer from "@/components/Footer"

export default function Error({
    error,
}: {
    error: Error & { digest?: string; message?: string }
}) {
    return (
        <>
            <main className="enq-content">
                <div className="enquete">
                    <ErrorContainer error={error} />
                </div>
            </main>
            <Footer />
        </>
    )
}
